<template>
<div class='column-tree-table'>
    <column-tree-table-column v-for='column in data.columns' :key='column.id' :data='column' :layer='layer' :focus='focus' :color-map='colorMap' :data-version='dataVersion'/>
</div>
</template>

<script>
import ColumnTreeTableColumn from '@/components/ColumnTreeTable/ColumnTreeTableColumn.vue';

export default {
  name: 'ColumnTreeTable',
  components: { ColumnTreeTableColumn },
  props: {
    data: {
      required: true,
      type: Object,
    },
    layer: {
      required: false,
      type: Array,
      default: () => [],
    },
    focus: {
      required: false,
      type: String,
      default: '',
    },
    colorMap: {
      required: false,
      type: Object,
      default: () => undefined,
    },
    dataVersion: {
      required: true,
      type: Number,
    },
  },
};
</script>
<style lang='scss' scoped>
.column-tree-table{
  display: flex;
  flex-direction: row;
  min-width: fit-content;
}
</style>
